import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { URLS } from "src/components/constants/appConstants";

/**
 * Redirects legacy /getard and /getard/:id URLs to JemGen.
 * When an ARD ID is present, it is passed as the selectedArdId query parameter
 * so JemGen can auto-select it.
 */
export function GetArdRedirect() {
  const { id } = useParams();

  const target = id
    ? `${URLS.JEM_GEN}?selectedArdId=${encodeURIComponent(id)}`
    : URLS.JEM_GEN;

  return <Navigate to={target} replace />;
}
